const mask = {
    CNPJ: "99.999.999/9999-99",
    PHONE: "(99) 99999999",
    CELLPHONE: "(99) 999999999",
    CEP: "99999-999",
}

export default mask;